import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { BasicSearchDropdown } from '@modules/feed/components/BasicSearchDropdown';
import { useFetchLabelRecommendations } from '@modules/feed/hooks';
import { WelcomeMessage } from '@modules/home/components/WelcomeMessage';
import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { BasicSearchRecommendations } from '../BasicSearchRecommendations';

export function BasicSearch() {
  const { showErrorNotification } = useNotificationContext();
  const {
    error,
    loading,
    refetch,
    recommendations: { entities, reasons },
  } = useFetchLabelRecommendations();

  useEffect(() => {
    if (error) {
      showErrorNotification({
        contentComponent: 'Failed to fetch search recommendations.',
        props: {},
      });
    }
  }, [error, showErrorNotification]);

  return (
    <Stack
      alignItems="center"
      sx={{ pt: 4.5, px: 5, maxWidth: '1200px', m: '0 auto' }}
    >
      <Stack width="100%" spacing={16}>
        <WelcomeMessage />
        <Stack width="100%" spacing={7}>
          <BasicSearchDropdown />
          <BasicSearchRecommendations
            loading={loading}
            trackedKeywords={entities}
            reasons={reasons}
            refetchRecommendations={refetch}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
